import { selectApiData } from 'util/selector/apiSelector';
import { selectAppException } from 'util/selectAppException';

import { AxiosInstance } from 'axios';
import { BatchException } from 'exception/BatchException';
import { JobModel, mapJobDtoToModel } from 'api/dto/Job.dto';
import { JobDto, JobExtendedModel, mapJobDtoToExtendedModel } from 'api/dto/JobExtended.dto';

export class JobApi {
  constructor(private api: AxiosInstance) {}

  listForProject(projectId: number): Promise<JobModel[]> {
    return this.api
      .get(`/api/v1/project/${projectId}/job`)
      .then(selectApiData)
      .then((entries: JobDto[]) => entries.map((entry) => mapJobDtoToModel(entry, projectId)));
  }

  listForDistribution(distributionId: string): Promise<JobExtendedModel[]> {
    return this.api
      .get(`/api/v1/distribution/${distributionId}/job`)
      .then(selectApiData)
      .then((entries) => entries.map((entry: JobDto) => mapJobDtoToExtendedModel(entry)));
  }

  changeVisited(projectId: number, jobId: number): Promise<any> {
    return this.api.post(`/api/v1/project/${projectId}/job/${jobId}/visited`);
  }

  get(jobId: number): Promise<JobModel> {
    return this.api
      .get(`/api/v1/job/${jobId}`)
      .then(selectApiData)
      .then((entry: JobDto) => {
        if (entry.reason) {
          throw new BatchException(entry.reason.map(selectAppException));
        }

        return mapJobDtoToModel(entry);
      });
  }
}
